import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { grey200 } from 'styles/colors';

export const Wrapper = styled.div``;

export const Row = styled.div`
	display: flex;
	align-items: stretch;
	padding: 0 0 2% 0;
`;

export const EmailWrapper = styled.div`
	width: 400px;
	> div {
		padding: 0 10% 0 0;
	}
`;

export const CompanyWrapper = styled.div`
	width: 200px;
	> button {
		width: 85%;
		height: 43px;
		border: 1px solid ${grey200};
	}
`;

export const RemoveWrapper = styled.div`
	flex-grow: 2;
	> div > button {
		height: 43px;
	}
`;

export const FormLabel = styled.label`
	text-overflow: ellipsis;
	margin-bottom: 8px;
	color: ${colors.grey500};
	max-width: 100%;
	display: inline-block;
	white-space: nowrap;
	overflow: hidden;
	letter-spacing: 0.8px;
	line-height: 13px;
	text-transform: uppercase;
	font-size: 11px;
	font-weight: 400;
	visibility: ${props => (props.hide === '1' ? 'hidden' : 'visible')};
`;

export const Actions = styled.div`
	width: 100%;
	display: flex;
	padding: 1% 0 0 0;
	justify-content: space-between;
`;

export const DropdownWrapper = styled.div``;
